import { render, staticRenderFns } from "./RicohConsultingServices.vue?vue&type=template&id=69bd65a2&scoped=true&"
import script from "./RicohConsultingServices.vue?vue&type=script&lang=js&"
export * from "./RicohConsultingServices.vue?vue&type=script&lang=js&"
import style0 from "./RicohConsultingServices.vue?vue&type=style&index=0&id=69bd65a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd65a2",
  null
  
)

export default component.exports